/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetProjectListResponseItems,
    GetProjectListResponseItemsFromJSON,
    GetProjectListResponseItemsFromJSONTyped,
    GetProjectListResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetProjectListResponse
 */
export interface GetProjectListResponse {
    /**
     * 
     * @type {Array<GetProjectListResponseItems>}
     * @memberof GetProjectListResponse
     */
    items: Array<GetProjectListResponseItems>;
}

export function GetProjectListResponseFromJSON(json: any): GetProjectListResponse {
    return GetProjectListResponseFromJSONTyped(json, false);
}

export function GetProjectListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProjectListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetProjectListResponseItemsFromJSON)),
    };
}

export function GetProjectListResponseToJSON(value?: GetProjectListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(GetProjectListResponseItemsToJSON)),
    };
}


